const isDevelopment = process.env.NODE_ENV === 'development';




export const devLog = (...args) => {
    if (isDevelopment) { 
        console.log(...args)
    }
}


export const devWarn = (...args) => {
    if (isDevelopment) {
        console.warn(...args)
    }
}